import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import {
    createDesignProjectMutationResponse,
    CreateDesignProjectMutationInput,
    createDesignProjectMutation,
} from './__generated__/createDesignProjectMutation.graphql';

const mutation = graphql`
    mutation createDesignProjectMutation($input: CreateDesignProjectMutationInput!) {
        createDesignProject(input: $input) {
            project {
                internalEditUrl
                editUrl
            }
        }
    }
`;

export default async function(
    environment: Environment,
    input: CreateDesignProjectMutationInput
): Promise<createDesignProjectMutationResponse> {
    return await commitMutation<createDesignProjectMutation>(environment, {
        mutation,
        variables: {
            input,
        },
    });
}
